
export const CREATE_TAG_LOADING_TAG: string = 'create-tag-loader-tag';
export const GET_TAG_LOADING_TAG: string = 'get-tag-loader-tag';